import styled from 'styled-components'

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 350px;
  height: auto;
  max-height: 100%;
`

export const LogoWrapper = styled.div`
  max-width: 307px;
  margin: 0 auto;
`

export const FloatingInputIcon = styled.div`
  float: right;
  top: -35px;
  position: relative;
  left: -15px;
  opacity: 0.65;
  &:hover {
    opacity: 1;
  }
`
